import * as THREE from "three";
import { FikoThreeJsComponent } from "../fiko-three-js.component";

export class FikoOrthoKamera extends THREE.OrthographicCamera {
    [key: string]: any;
    override type: any = "FikoOrthoKamera";

    constructor(public anaGosterim: FikoThreeJsComponent) {
        super(
            anaGosterim.canvas.nativeElement.clientWidth / - 2,
            anaGosterim.canvas.nativeElement.clientWidth / 2,
            anaGosterim.canvas.nativeElement.clientHeight / 2,
            anaGosterim.canvas.nativeElement.clientHeight / - 2,
            -100000, 100000
        );
        // this.up.set(0, 0, 1)
        // this.rotation.order = 'XYZ';
        this.position.set(0, 0, 100);
        this.zoom = 1;
        this.frustumCulled = false;
        this.updateProjectionMatrix();

        // let light = new THREE.PointLight(0xffffff, 10);
        // light.castShadow = true;
        // this.add(light);
    }

    // clone(recursive?: boolean): FikoObje3D {
    //     let kopya:FikoOrthoKamera = super.clone(true) as FikoOrthoKamera;
    //     kopya.left=this.anaGosterim.canvas.nativeElement.clientWidth / - 2;
    //     kopya.right=this.anaGosterim.canvas.nativeElement.clientWidth / 2;
    //     kopya.top=this. anaGosterim.canvas.nativeElement.clientHeight / 2;
    //     kopya.bottom=this.anaGosterim.canvas.nativeElement.clientHeight / - 2;
    //     return kopya;
    // }

    okuJsondan(json: any) {
        this.up.fromArray(json.ust);
        this.zoom = json.yakinlik;
        this.matrix.fromArray(json.matriks);
        this.matrix.decompose(this.position, this.quaternion, this.scale);

        this.anaGosterim.aktifKontrol.target.fromArray(json.hedef);
        this.anaGosterim.aktifKontrol.update();
        this.updateProjectionMatrix()
    }

    // override toJSON() {
    //     return {
    //         matriks: this.matrix.toArray(),
    //         hedef: this.anaGosterim.aktifKontrol.target.toArray(),
    //         position: this.position.toArray(),
    //         quaternion: this.quaternion.toArray(),
    //         scale: this.scale.toArray(),
    //         ust: this.up.toArray(),
    //         yakinlik: this.zoom,
    //         oran: this.anaGosterim.canvas.nativeElement.clientWidth / this.anaGosterim.canvas.nativeElement.clientHeight,
    //     }
    // }

}